import { Injectable } from '@angular/core';
import { ProjectAnalysisReport, ProjectSummary } from '../../../core/models/analysis-report';

@Injectable({ providedIn: 'root' })
export class AnalysisScoringService {

  private static readonly PASS_THRESHOLD = 5;

  cleanCodeScore(summary: ProjectSummary | null | undefined): number {
    if (!summary) return 0;
    const penalty =
      4.0 * (summary.criticalViolations || 0) +
      1.0 * (summary.majorViolations || 0) +
      0.1 * (summary.minorViolations || 0);
    return Math.max(0, 10 - penalty);
  }

  codeSmellsScore(summary: ProjectSummary | null | undefined): number {
    if (!summary) return 0;
    const penalty =
      4.0 * (summary.criticalSmells || 0) +
      1.0 * (summary.majorSmells || 0) +
      0.1 * (summary.minorSmells || 0);
    return Math.max(0, 10 - penalty);
  }

  securityScore(summary: ProjectSummary | null | undefined): number {
    if (!summary) return 0;
    const penalty =
      4.0 * (summary.criticalVulnerabilities || 0) +
      1.0 * (summary.highVulnerabilities || 0) +
      0.4 * (summary.mediumVulnerabilities || 0) +
      0.1 * (summary.lowVulnerabilities || 0);
    return Math.max(0, 10 - penalty);
  }

  qualityGatePassed(report: ProjectAnalysisReport | null | undefined): boolean {
    if (!report?.summary) return false;
    const type = report.analysisType;
    const summary = report.summary;
    const checks: boolean[] = [];
    if (!type || type === 'CLEAN_CODE') checks.push(this.cleanCodeScore(summary) >= AnalysisScoringService.PASS_THRESHOLD);
    if (!type || type === 'CODE_SMELLS') checks.push(this.codeSmellsScore(summary) >= AnalysisScoringService.PASS_THRESHOLD);
    if (!type || type === 'SECURITY') checks.push(this.securityScore(summary) >= AnalysisScoringService.PASS_THRESHOLD);
    return checks.length > 0 && checks.every(c => c);
  }

  getRating(score: number): string {
    if (score >= 9) return 'A';
    if (score >= 7) return 'B';
    if (score >= 5) return 'C';
    if (score >= 3) return 'D';
    return 'E';
  }

  formatScore(score: number): string {
    return score.toFixed(1);
  }
}
